class PageTop {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){
    (function ($) {
      var pagetop = $('.footer__toTop');
        
      pagetop.click(function () {
        $('body, html').animate({
            scrollTop: 0
        }, 600);
        return false;
      });
    })(jQuery);
  }
}
